(function() {
  window.tito =
    window.tito ||
    function() {
      (tito.q = tito.q || []).push(arguments);
    };

  function setBadgeSlug(slug) {
    if(!slug) {
      return;
    }

    let btn = document.getElementById("lanyardify-link");

    if(!btn.getAttribute("data-original-href")) {
      btn.setAttribute("data-original-href", btn.getAttribute("href"));
    }

    let newUrl = `${btn.getAttribute("data-original-href")}${slug}/`;
    btn.setAttribute("href", newUrl);
  }

  function setCookie(name, value) {
    let d = new Date();
    let durationDays = 60;
    d.setTime( d.getTime() + (durationDays * 24 * 60 * 60 * 1000) );

    let domain = "";
    document.cookie = name + "=" + value + ";secure;samesite=lax;expires=" + d.toUTCString() + ";path=/" + (domain ? ";domain=" + domain : "");
  }

  tito('on:registration:finished', function(data){
    setBadgeSlug(data.slug);

    // overwrites any existing saved ticket slug
    setCookie("jamstack-last-ticket-registration-slug", data.slug)
  });

  // Workshop discount codes
  let params = new URLSearchParams(window.location.search ? window.location.search.substr(1) : "");
  let discountCode = params.get("discount");
  if(discountCode) {
    let buttons = document.querySelectorAll("tito-button");
    for(let button of buttons) {
      button.setAttribute("discount-code", discountCode);
    }
  }
})();